import React from "react"
import Chip from "material-ui/Chip"
interface IProps {
    index: number
    ordered: boolean
    order: number
    name: string
    code: string
    readonly: boolean
    onDeleteRequest(): void
}

const TaskItem: React.SFC<IProps> = (props: IProps) => {
    return (
        <div className="TaskItem">
            <Chip
                style={{ cursor: "pointer", margin: 2, height: 35 }}
                onRequestDelete={() => !props.readonly && props.onDeleteRequest()}
            >
                <span>
                    <b>
                        {props.ordered && <span>{props.order}. </span>}
                        {props.code}
                    </b>{" "}
                    {props.name}
                </span>
            </Chip>
        </div>
    )
}

export default TaskItem
